import Cue from '../../../../../State/Stores/Captions/Cue';

/**
 * Creates a string representation of a list of n number of cues, to
 * simplify diffing on `TextTrack` component re-render.
 */

const serialiseActiveCues = (activeCues: Cue[]): string => activeCues.map(cue => cue.text).join('');

export default serialiseActiveCues;
